/* eslint-disable no-param-reassign */
import { IReportReducer } from 'utils/types';

export const resetReportReceiptOperation = (state: IReportReducer): void => {
	state.receipt.data = null;
};
